import type { ZustandStore } from '../store.type';
import type { NamedSet } from 'zustand/middleware';

type InvitationState = {
	invitation: {
		username: string;
		firstName: string;
		lastName: string;
		isFormLoading: boolean;
	};
};

type InvitationActions = {
	setInvitationFirstName: (firstName: InvitationState['invitation']['firstName']) => void;
	setInvitationUserName: (userName: InvitationState['invitation']['username']) => void;
	setInvitationLastName: (lastName: InvitationState['invitation']['lastName']) => void;
	setInvitationFormLoading: (isFormLoading: InvitationState['invitation']['isFormLoading']) => void;
	resetInvitationForm: () => void;
};

export type InvitationSlice = InvitationState & InvitationActions;

const initialState = {
	username: '',
	firstName: '',
	lastName: '',
	isFormLoading: false,
};

const invitationInitialState: InvitationState = {
	invitation: initialState,
};

export function invitationSlice(set: NamedSet<ZustandStore>): InvitationSlice {
	return {
		...invitationInitialState,
		setInvitationUserName: (username: InvitationState['invitation']['username']) => {
			set(
				(state: InvitationState) => {
					state.invitation.username = username;
					return state;
				},
				false,
				'[setInvitationUsername]',
			);
		},
		setInvitationFirstName: (firstName: InvitationState['invitation']['firstName']) => {
			set(
				(state: InvitationState) => {
					state.invitation.firstName = firstName;
					return state;
				},
				false,
				'[setInvitationFirstName]',
			);
		},
		setInvitationLastName: (lastName: InvitationState['invitation']['lastName']) => {
			set(
				(state: InvitationState) => {
					state.invitation.lastName = lastName;
					return state;
				},
				false,
				'[setInvitationLastName]',
			);
		},
		setInvitationFormLoading: (isFormLoading: InvitationState['invitation']['isFormLoading']) => {
			set(
				(state: InvitationState) => {
					state.invitation.isFormLoading = isFormLoading;
					return state;
				},
				false,
				'[setInvitationFormLoading]',
			);
		},
		resetInvitationForm: () => {
			set(
				(state: InvitationState) => {
					state.invitation = initialState;
					return state;
				},
				false,
				'[resetInvitationForm]',
			);
		},
	};
}
